/**
 * Angular App Config Service.
 *
 * @file Main Angular's application service provider.
 */
import { Injectable } from '@angular/core';
import { IConfig } from '../models/config.model';

@Injectable ()
export class AppConfigService {

    private _config: IConfig;
    public setConfig(config: IConfig) {

        this._config = {...config};
    }

    public isDesignMode() : boolean {
        return (this._config && this._config.consumer === "themedesigner");
    }

    constructor () {
    }


}
